import { MainPanelAction } from './MainPanelAction'
import { MainPanelBar } from './MainPanelBar'
import { MainPanelContent } from './MainPanelContent'
import { MainPanelItem } from './MainPanelItem'
import { MainPanelLabel } from './MainPanelLabel'
import { MainPanelLane } from './MainPanelLane'
import { MainPanelSlot } from './MainPanelSlot'

interface MainPanelProps {
  children?: React.ReactNode
}

export const MainPanel = ({ children }: MainPanelProps) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%',
        height: '100%',
        padding: '0 16px',
        overflow: 'hidden',
        background: '#fff',
        borderRadius: '4px',
      }}
    >
      {children}
    </div>
  )
}

MainPanel.Bar = MainPanelBar
MainPanel.Slot = MainPanelSlot
MainPanel.SlotLabel = MainPanelLabel
MainPanel.SlotAction = MainPanelAction
MainPanel.SlotItem = MainPanelItem
MainPanel.Content = MainPanelContent
MainPanel.Lane = MainPanelLane
